import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { subjectsApi } from '../api/subjectsApi'
import type { Subject, SubjectDraft, SubjectStatus } from '../model/subject'

export interface SubjectsState {
  items: Subject[]
  status: 'idle' | 'loading' | 'ready' | 'error'
  error: string | null
}

const initialState: SubjectsState = { items: [], status: 'idle', error: null }

export const loadSubjects = createAsyncThunk('subjects/load', async (force: boolean | undefined, { getState }) => {
  const state = (getState() as { subjects?: SubjectsState }).subjects
  if (!force && state?.status === 'ready') return state.items
  return subjectsApi.list()
})
export const saveSubject = createAsyncThunk('subjects/save', async (input: { id?: number; draft: SubjectDraft }) => input.id ? subjectsApi.update(input.id, input.draft) : subjectsApi.create(input.draft))
export const setSubjectStatus = createAsyncThunk('subjects/setStatus', async (input: { id: number; status: SubjectStatus }) => subjectsApi.setStatus(input.id, input.status))
export const removeSubject = createAsyncThunk('subjects/remove', async (id: number) => { await subjectsApi.remove(id); return id })

const slice = createSlice({
  name: 'subjects',
  initialState,
  reducers: {
    upsertSubject(state, action: { payload: Subject }) {
      const index = state.items.findIndex(item => item.id === action.payload.id)
      if (index >= 0) state.items[index] = action.payload
      else state.items.push(action.payload)
      state.items.sort((left, right) => left.sort_order - right.sort_order || left.name.localeCompare(right.name))
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loadSubjects.pending, state => { state.status = 'loading'; state.error = null })
      .addCase(loadSubjects.fulfilled, (state, action) => { state.status = 'ready'; state.items = action.payload })
      .addCase(saveSubject.fulfilled, (state, action) => {
        state.status = 'ready'
        const index = state.items.findIndex(item => item.id === action.payload.id)
        if (index >= 0) state.items[index] = action.payload
        else state.items.push(action.payload)
        state.items.sort((left, right) => left.sort_order - right.sort_order || left.name.localeCompare(right.name))
      })
      .addCase(setSubjectStatus.fulfilled, (state, action) => {
        state.status = 'ready'
        const index = state.items.findIndex(item => item.id === action.payload.id)
        if (index >= 0) state.items[index] = action.payload
      })
      .addCase(removeSubject.fulfilled, (state, action) => { state.status = 'ready'; state.items = state.items.filter(item => item.id !== action.payload) })
      .addMatcher(action => action.type.startsWith('subjects/') && action.type.endsWith('/rejected'), (state, action: { error: { message?: string } }) => { state.status = 'error'; state.error = action.error.message || 'Không thể tải dữ liệu môn học.' })
  },
})

export const subjectsReducer = slice.reducer
export const subjectsActions = slice.actions
